import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class ExtraOvertime extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        // is Tied After End Of Current Overtime
        return (
            fragment.associatedState === FootballState.EndOfPlay &&
            gameContext.isATie() &&
            gameContext.getOvertimePeriod() &&
            gameContext.homeTeamOvertimeDrive &&
            gameContext.awayTeamOvertimeDrive
        );
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.triggerExtraOvertime = true;
        gameContext.homeTeamOvertimeDrive = false;
        gameContext.awayTeamOvertimeDrive = false;
    }
}
